// React Libraries
import React from 'react';
// External Libraries
import parser from 'html-react-parser';
// Material UI
import Snackbar from '@mui/material/Snackbar';

import MuiAlert from '@mui/material/Alert';

const GeneralSnackBar = ({ snackbar }) => {
    if (!snackbar.open) {
        return null;
    }

    return (
        <Snackbar
            anchorOrigin={{
                vertical: `${snackbar.vertical}`,
                horizontal: `${snackbar.horizontal}`,
            }}
            id={`${snackbar.variant}-snackbar`}
            autoHideDuration={snackbar.duration}
            onClose={snackbar.onCloseFunc}
            open={snackbar.open}
        >
            <MuiAlert
                elevation={6}
                variant="filled"
                onClose={snackbar.onCloseFunc}
                severity={snackbar.variant}
                slotProps={{
                    closeButton: {
                        'aria-hidden': 'true',
                    },
                }}
            >
                {parser(snackbar.message)}
            </MuiAlert>
        </Snackbar>
    );
};

export default GeneralSnackBar;
